// React
import React from "react";

// Material-UI (Core)
import { Box } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";

// Libraries
import { useObserver } from "mobx-react-lite";

// Core
import { StoresInstance } from "Core/Base";
import { CSSGrid, Cell } from "Core/Components/Styles";

// Custom
import { Header } from "./Header";
import { PageHeader } from "Custom/Components/PageHeader";

// Layout Component
export const Layout: React.FC<{}> = props => {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

    return useObserver(() => {
        const canDisplayHeader = StoresInstance.domain.AccountStore.IsLoggedIn;

        const areas = canDisplayHeader ? ["header", "content"] : ["content"];

        return (
            <CSSGrid areas={areas} columns={"1fr"} gap={"0px"} rows={"42px 1fr"} style={{ height: "100%" }}>
                {canDisplayHeader && (
                    <Cell area="header" style={{ maxHeight: "42px" }}>
                        <Header />
                    </Cell>
                )}

                <Cell
                    area="content"
                    id="content"
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                    }}
                >
                    {canDisplayHeader && !isDesktop && <PageHeader />}
                    {props.children}
                </Cell>
            </CSSGrid>
        );
    });
};
